const defaultLocale = {
  okText: '确定',
  cancelText: '取消',
  justOkText: '知道了',
};

let runtimeLocale = { ...defaultLocale };

export function changeConfirmLocale(newLocale) {
  if (newLocale) {
    runtimeLocale = { ...runtimeLocale, ...newLocale };
  } else {
    runtimeLocale = { ...defaultLocale };
  }
}

export function getConfirmLocale() {
  // if (this.context.antLocale && this.context.antLocale.Popconfirm) {
  //   runtimeLocale = {...this.context.antLocale.Popconfirm}
  // }
  return runtimeLocale;
}



// WEBPACK FOOTER //
// ./_antd1.11.2/modal/locale.js